/**********************
 LibShopgate (Header)
 ***********************/

import SGEventProto from '../app/sg-event/SGEvent';

// helper object that store functions, objects or other data that shouldn't
// be included in the default Lib objects
window.SGAppHelpers = {};

window.SGViewState = {
	insets: {
		bottom: 0,
		left: 0,
		right: 0,
		top: 0
	},
	menuBarIsVisible: false
};

SGViewState.getInset = function(type) {
	if (type && SGViewState.insets[type]) {
		return SGViewState.insets[type];
	}
	return 0;
};

window.SGWebStorageTimeouts = {
	productDetails: 300
};

window.SGAction = (function() {
	"use strict";

	var SGAction = function() {
		this.debug = _debugEnabled();

		this.debugout = function(m) {console.log(m);};
		this.locchange = true;
        this.version = typeof libVersion !== 'undefined' && libVersion ? libVersion : '1.0';

		this.collectionMode = false;

		return this;
	};

	/**
	 * Checking if debug should be enabled on start
	 * @returns {boolean}
	 * @private
     */
	function _debugEnabled() {
		// check if developer made explicit choice
		if (
			window.localStorage
			&& window.localStorage.getItem
			&& typeof window.localStorage.getItem === 'function'
		) {
			var magicKey = window.localStorage.getItem('sg_debug');
			if (magicKey === 'enabled') {
				return true;
			}

			if (magicKey === 'disabled') {
				return false;
			}
		}

		// check if environment is development
		if (window.location.href.indexOf('localdev.cc') > -1) {
			return true;
		}

		return false;
	}

	return new SGAction();
})();

/**
 * The SGActionCollection is used to create and handle a list of hybid app commands.
 * @param  {Array} 		[initialData]
 * @param  {Function} 	[initialData].function
 * @param  {*} 			[initialData].params
 * @return {Object}     An SGActionCollection instance
 */
window.SGActionCollection = function(initialData) {
	// the actionCollection
	this.collection = [];

	/**
	 * Adds a new SGAction command to the collection
	 * @param  {Function} 	fn     		The Lib function for the command
	 * @param  {*}   		[params] 	Additional parameters for the command. Usually and object.
	 */
	this.add = function(fn, params) {
		if (typeof fn === 'function') {
			this.collection.push({function: fn, params: params});
		}
	};

	/**
	 * Adds a new SGAction command as first element to the collection
	 * @param  {Function} 	fn     		The Lib function for the command
	 * @param  {*}   		[params] 	Additional parameters for the command. Usually and object.
	 */
	this.prepend = function(fn, params) {
		this.collection.reverse();
		this.add(fn, params);
		this.collection.reverse();
	};

	/**
	 * Adds an array of SGActionCommands to the collection
	 * @param  {Array} collectionData The array that contains the collection data
	 */
	this.addCollectionData = function(collectionData) {
		// check as much as possible before adding the data
		if (Array.isArray(collectionData)) {
			for (var collectionDataIndex = 0; collectionDataIndex < collectionData.length; collectionDataIndex++) {
				if (collectionData[collectionDataIndex].hasOwnProperty('function') && typeof collectionData[collectionDataIndex].function === 'function') {
					this.collection.push(collectionData[collectionDataIndex]);
				}
			}
		}
	};

	/**
	 * Returns the current SGActionCollection
	 * @return {Array]} The current SGActionCollection
	 */
	this.get = function() {
		var SGActionCommands = [],
			previousCollectionMode = SGAction.collectionMode;

		// make sure that the collection is really an array
		if (Array.isArray(this.collection)) {
			// activate the collection mode
			SGAction.collectionMode = true;

			for (var collectionIndex = 0; collectionIndex < this.collection.length; collectionIndex++ ) {
				// only process valid collection entries
				if (this.collection[collectionIndex].hasOwnProperty('function')) {
					// try to call the action to get a result
					var callResult = this.collection[collectionIndex].function.call(SGAction, this.collection[collectionIndex].params);

					// ensure that only SGActionCommands are added to the SGActionCommand array
					if (callResult) {
						for (var callResultIndex = 0; callResultIndex < callResult.length; callResult++) {
							if (callResult[callResultIndex] instanceof SGActionCommand) {
								SGActionCommands.push(callResult[callResultIndex]);
							}
						}
					}
				}
			}

			// reset the collection mode to the previous state
			SGAction.collectionMode = previousCollectionMode;
		}

		return SGActionCommands;
	};

	/**
	 * Sends the current SGActionCollection to the app
	 */
	this.send = function() {
		var previousCollectionMode = SGAction.collectionMode;

		// deactivate the collection mode
		SGAction.collectionMode = false;

		// dispatch the command list
		SGAction.dispatchCommands(this.get());

		// reset the collection mode to the previous state
		SGAction.collectionMode = previousCollectionMode;
	};

	if (initialData) {
		this.addCollectionData(initialData);
	}

	return this;
};

window.SGEvent = new SGEventProto();

window.openUrl = function (options) {
	var defaults = {
		sgcommands: [],
		src: '',
		noHistory: false
	};

	options = options || {};
	options = $.extend({}, defaults, options);

	if (Array.isArray(options.sgcommands) && options.sgcommands.length) {
		// dispatch commands if available
		SGAction.prepareCommandsForDispatch(options.sgcommands);
	} else if (options.src) {

		if (options.src.match(/^sgapi:$/i)) {
			// skip links and links that only contain "sgapi:"
			return false;
		} else if (options.src.match(/^(sgapi:|http(?:s)?:\/\/)/i) === null) {
			// add "sgapi:" to links without a valid protocol
			options.src = 'sgapi:' + options.src;
		}

		var addHistoryEntry = !options.noHistory;

		// remove unnecessary options
		delete(options.sgcommands);
		delete(options.noHistory);

		// decide how to open the link
		if (addHistoryEntry) {
			SGAction.openPage(options);
		} else {
			SGEvent.Broadcast.mainViewWillBeReplaced();
			SGAction.replacePage(options);
		}
	} else {
		console.warn('.sg-action class without data-sgaction or href attr');
	}
}

window.checkClientIsShopgateApp = function () {
	return (sgData.device && sgData.device.access == "App") || $('body').hasClass('app');
};

window.createGUID = (function() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	return function() {
		return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
			s4() + '-' + s4() + s4() + s4();
	};
})();

window.windowGUID = createGUID();

// TODO: move to common js or something else!
window.rgb2hex = function (rgb) {
	rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
	function hex(x) {
		return ("0" + parseInt(x).toString(16)).slice(-2);
	}
	return "" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
};

/**
 * The LibShopgateVersion object provides several functions to perform version checks
 * to the LibShopgate and strings containing version numbers. It also provides some flags to
 * check if certain features are active within the current LibShopgate version.
 */
window.LibShopgateVersion = (function() {
	"use strict";

	var LibShopgateVersion = function() {
		var _this 					= this;

		// Take care that there is always a version string available
		_this.version 				= SGAction.version ? SGAction.version : '1.0';

		_this.isLibVersionAtLeast  	= _isLibVersionAtLeast;
		_this.isLibVersionAtMost 	= _isLibVersionAtMost;
		_this.isLibVersion 			= _isLibVersion;
		_this.isVersionAtLeast 		= _isVersionAtLeast;
		_this.isVersionAtMost 		= _isVersionAtMost;
		_this.isVersion 			= _isVersion;
		_this.updateLibVersion		= _updateLibVersion;

		/**
		 * Updates the internal lib version
		 * @param {numeric} version
		 */
		function _updateLibVersion(version) {
			_this.version = version;
			SGAction.version = version;
		}

		/**
		 * Checks if the LibShopgate has an explicit version number
		 * @param  {int}  expectedMajor
		 * @param  {int}  expectedMinor
		 * @param  {int}  expectedMicro
		 * @return {boolean}
		 */
		function _isLibVersion(expectedMajor, expectedMinor, expectedMicro) {
			return _isLibVersionAtLeast(expectedMajor, expectedMinor, expectedMicro) == _isLibVersionAtMost(expectedMajor, expectedMinor, expectedMicro);
		}

		/**
		 * Checks if the LibShopgate has at least a specific version number
		 * @param  {string}  versionString The version string
		 * @param  {int}  expectedMajor
		 * @param  {int}  expectedMinor
		 * @param  {int}  expectedMicro
		 * @return {boolean}
		 */
		function _isLibVersionAtLeast(expectedMajor, expectedMinor, expectedMicro) {
			return _isVersionAtLeast(_this.version, expectedMajor, expectedMinor, expectedMicro);
		}
		/**
		 * Checks if the LibShopgate has at most a specific version number
		 * @param  {string}  versionString The version string
		 * @param  {int}  expectedMajor
		 * @param  {int}  expectedMinor
		 * @param  {int}  expectedMicro
		 * @return {boolean}
		 */
		function _isLibVersionAtMost(expectedMajor, expectedMinor, expectedMicro) {
			return _isVersionAtMost(_this.version, expectedMajor, expectedMinor, expectedMicro);
		}

		/**
		 * Checks if a version string represents an explicit version number
		 * @param  {string}  versionString The version string
		 * @param  {int}  expectedMajor
		 * @param  {int}  expectedMinor
		 * @param  {int}  expectedMicro
		 * @return {boolean}
		 */
		function _isVersion(versionString, expectedMajor, expectedMinor, expectedMicro) {
			return _isVersionAtLeast(versionString, expectedMajor, expectedMinor, expectedMicro) == _isVersionAtMost(versionString, expectedMajor, expectedMinor, expectedMicro);
		}

		/**
		 * Checks if a version string represents at least a specific version number
		 * @param  {string}  versionString The version string
		 * @param  {int}  expectedMajor
		 * @param  {int}  expectedMinor
		 * @param  {int}  expectedMicro
		 * @return {boolean}
		 */
		function _isVersionAtLeast(versionString, expectedMajor, expectedMinor, expectedMicro) {
			return _versionCheck('at_least', versionString, expectedMajor, expectedMinor, expectedMicro);
		}

		/**
		 * Checks if a version string represents at most a specific version number
		 * @param  {string}  versionString The version string
		 * @param  {int}  expectedMajor
		 * @param  {int}  expectedMinor
		 * @param  {int}  expectedMicro
		 * @return {boolean}
		 */
		function _isVersionAtMost(versionString, expectedMajor, expectedMinor, expectedMicro) {
			return _versionCheck('at_most', versionString, expectedMajor, expectedMinor, expectedMicro);
		}

		/**
		 * Prepares basic data for the version checks
		 * @param  {string}  mode The mode for the version check function. 'at_most'|'at_least'
		 * @param  {string}  versionString The version string
		 * @param  {int}  expectedMajor
		 * @param  {int}  expectedMinor
		 * @param  {int}  expectedMicro
		 * @return {boolean|array} An array that contains the version number segments or FALSE
		 */
		function _versionCheck(mode, versionString, expectedMajor, expectedMinor, expectedMicro) {
			// initialize the parameters
			mode = mode || '';
			versionString = versionString || '';
			versionString = versionString.trim();
			expectedMajor = expectedMajor || 0;
			expectedMinor = expectedMinor || 0;
			expectedMicro = expectedMicro || 0;

			var spaceIndex = versionString.indexOf(' '),
				versionComponents = null;

			// cut suffixes (for example: Beta)
			if (spaceIndex >= 0) {
				versionString = versionString.substring(0, spaceIndex);
			}

			// split the version number
			versionComponents = versionString.split('.');

			if (versionComponents.length === 0) {
				return false;
			}

			while (versionComponents.length < 3) {
				versionComponents.push(0);
			}

			if (mode == 'at_most') {
				// the actual check for the at most mode
				if (versionComponents[0] != expectedMajor) {
					return (versionComponents[0] < expectedMajor);
				}

				if (versionComponents[1] != expectedMinor) {
					return (versionComponents[1] < expectedMinor);
				}

				return (versionComponents[2] <= expectedMicro);
			} else if (mode == 'at_least') {
				// the actual check for the at least mode
				if (versionComponents[0] != expectedMajor) {
					return (versionComponents[0] > expectedMajor);
				}

				if (versionComponents[1] != expectedMinor) {
					return (versionComponents[1] > expectedMinor);
				}

				return (versionComponents[2] >= expectedMicro);
			} else {
				return false;
			}
		}
	};

	return new LibShopgateVersion();
})();




// WEBPACK FOOTER //
// ./Library/1.0/common/LibShopgate.js